(function($, Global) {
    var SsoModel = function() {

        var hostSplit = document.location.host.split('.');
        var prefix = "";
        if (hostSplit.length > 2 && hostSplit[0] !== 'www') {
            prefix = hostSplit.slice(0, hostSplit.length - 2).join('.') + '.';
        }

        this.domain = 'https://' + prefix + 'api.indigo-net.com'

        this.authStatus = window.indigoSso.connected;
        this.ssoEnable = window.indigoSso.enable === 1;
        this.token = window.indigoSso.token
    }

	SsoModel.prototype.initEvents = function() {
        var self = this;

        if (!this.ssoEnable)
            return;

        self.check();
    }

    SsoModel.prototype.indigoLogin = function(token, reloadPage) {
        var self = this;

        if (!this.ssoEnable)
            return Global.location.reload();

        $.ajax({
			type: 'POST',
            dataType: 'json',
            data: '{}',
            xhrFields: {
                withCredentials: true
            },
			url: self.domain + '/api/sso/login?token=' + token,
			timeout: 25000
		})
            .always(function () {
                if (reloadPage)
                    Global.location.reload();
            });
    }

	SsoModel.prototype.login = function(token) {
        if (!this.ssoEnable)
            return;
        var prefix = '';
        var localPathName = window.location.pathname.toLowerCase();
        if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
        if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: prefix+'/ajax/login/ssologin',
            data: JSON.stringify({Token: token}),
            contentType: "application/json",
			timeout: 25000
        }).done(function (data, status) {
            if (data.isSuccess)
                Global.location.reload();
        })
    }

    SsoModel.prototype.logout = function() {
        var self = this;

        var redirectUrl = "/";
        var language = $('meta[name="PublicationLanguage"]').attr('content');
        if (language)
            redirectUrl = "/"  + language;

        if (!this.ssoEnable)
            return Global.location.replace(redirectUrl);

        $.ajax({
		    type: 'POST',
            dataType: 'json',
            data: '{}',
            xhrFields: {
                withCredentials: true
            },
		    url: self.domain + '/api/sso/logout',
			timeout: 25000
	    }).always(function (data, status) {
		    return Global.location.replace(redirectUrl);
	    })
    }

    SsoModel.prototype.getStatus = function() {
        var self = this;

        if (!this.ssoEnable)
            return;

        $.ajax({
			type: 'POST',
            dataType: 'json',
            data: '{}',
            xhrFields: {
                withCredentials: true
            },
			url: self.domain + '/api/sso?status=' + self.authStatus,
			timeout: 25000
		})
			.done(function (data, status) {
                if (self.authStatus === 1 && data.status === 2) {
                    var authModel = new AuthModel();
                    authModel.logout();
                } else if (self.authStatus === 2 && data.status === 1) {
                    self.login(data.token);
                }
			})
            .fail(function (jqXHR, textStatus) {
                if (jqXHR.status !== 401) {
                    console.log(jqXHR, textStatus)
                }
		    });
    }

    SsoModel.prototype.check = function() {
        var self = this;

        if (!this.ssoEnable)
            return;

        if (self.token) {
            self.indigoLogin(self.token, false)
        } else {
            self.getStatus();
        }
    }

	Global.SsoModel = SsoModel;
}(jQuery, window));